module.exports = __webpack_public_path__ + "static/img/mm.5e180386.svg";